import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'containsBy',
    standalone: false
})
export class ContainsByPipe implements PipeTransform {

  transform(list: any[], properties:string[] = [], propValue: string = ''): any[] {

    if (!list || properties.length == 0 || !properties) { 
      return list;
    }

    if (list.length < 1) {
       return list; 
    }

    return list
          .filter(obj => {
            return properties.filter(prop => {
              return obj[prop].toLowerCase().indexOf(propValue.toLowerCase()) > -1;
            }).length > 0;
          });
  }

}
